// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const colors: Styleguide["colors"] = {
    header: {
        main: "#ffffff", // None, look at header background color
        contrast: "#00539b", // Text Color -> Main
        hover: "#1a3a69", // Primary -> Dark
        accent: "#00539b", // Primary -> Main
        accentHover: "#1a3a69", // Primary -> Dark
        accentContrast: "#ffffff", // None, should match "primary.contrast"
    },
    menu: {
        secondaryNavigation: {
            main: "#ffffff", // Primary -> Dark
            contrast: "#00539b", // None, should match "primary.contrast"
            hover: "#1a3a69", // None, should match "primary.contrast"
        },
    },
};

export default colors;
